import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const eolDashboardPlugin = createPlugin({
  id: 'endoflife-dashboard',
  routes: {
    root: rootRouteRef,
  },
});

export const EolDashboardPage = eolDashboardPlugin.provide(
  createRoutableExtension({
    name: 'EolDashboardPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
